import * as CookieService from "@/services/cookie.service";
import { Cookie } from "@/services/cookie.service";

class EcornerService {
    static async getEcornerCookie() {
        return CookieService.get(Cookie.ECornerId);
    }

    static async getEcornerStoreIdCookie() {
        return CookieService.get(Cookie.ECornerStoreId);
    }

    static async getEcornerTerminalIdCookie() {
        return CookieService.get(Cookie.ECornerTerminalId);
    }

    static async getEcornerUrl(sku: string): Promise<{
        url?: string;
        urlParams?: Record<string, string>;
    }> {
        const ecornerId = await EcornerService.getEcornerCookie();

        if (ecornerId) {
            return {
                url: "/ecorners/:ecornerId/facing/:sku",
                urlParams: {
                    ecornerId,
                    sku
                }
            };
        }

        const ecornerStoreId = await EcornerService.getEcornerStoreIdCookie();

        if (ecornerStoreId) {
            return {
                url: "/ecorners/facing/:storeId/:sku",
                urlParams: {
                    storeId: ecornerStoreId,
                    sku
                }
            };
        }

        return {};
    }

    static async isEcornerEnvironment() {
        // Old ecorner environment
        if (await EcornerService.getEcornerCookie()) {
            return true;
        }

        // New ecorner environment
        if (
            (await EcornerService.getEcornerStoreIdCookie()) &&
            (await EcornerService.getEcornerTerminalIdCookie())
        ) {
            return true;
        }

        return false;
    }
}

export { EcornerService };
